/* Umya - el video de YouTube no se carga hasta que alguien lo pulsa.
 *
 * Estaba dentro de umya-ficha.js, que solo se carga desde el bloque de compra
 * de la joya. La ficha del curso ya no usa ese bloque, asi que el boton de
 * reproducir no hacia nada. Ahora el guion viaja con el fragmento.
 *
 * Va en captura sobre el documento: da igual cuando se pinte el video. */
(function () {
document.addEventListener('click', function (evento) {
  var boton = evento.target.closest('.umya-video__boton');
  if (!boton) return;

  var caja = boton.closest('[data-umya-video]');
  var id = caja && caja.dataset.id;
  if (!id) return;

  var marco = document.createElement('iframe');
  marco.src =
    'https://www.youtube-nocookie.com/embed/' +
    encodeURIComponent(id) +
    '?autoplay=1&rel=0';
  marco.title = boton.getAttribute('aria-label') || '';
  marco.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
  marco.allowFullscreen = true;

  caja.innerHTML = '';
  caja.appendChild(marco);
});
})();
